
<p i18n>
 Attention : Maintenance planifiée le {{alertStartTime}} à {{alertStartHour}}. {{alertMessage}}
